import { render, staticRenderFns } from "./FullName.vue?vue&type=template&id=3b57dfc2&scoped=true"
import script from "./FullName.vue?vue&type=script&lang=js"
export * from "./FullName.vue?vue&type=script&lang=js"
import style0 from "./FullName.vue?vue&type=style&index=0&id=3b57dfc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b57dfc2",
  null
  
)

export default component.exports